import styled from "styled-components";
import { Flexbox } from "@talentbait/shared-components";

export default styled(Flexbox)`
  background-color: ${({ theme }) => theme.colors.shades.white};
  border-radius: 10px;
  height: 100%;
  width: 100%;
  margin-top: max(10%, 80px);
  ${({ theme }) => theme.breakpoints.mobile} {
    margin-top: 0;
  }
  @media (max-height: 800px) {
    margin-top: 0;
  }
  max-height: 800px;
  overflow: hidden;
`;
